import React from 'react'
import { Table } from 'antd'
import { useLocation, useNavigate } from 'react-router-dom'

interface Props {
  rowKey?: string
  columns: any
  data: any
  isPagination?: any
  loading?: boolean
  height?: number
  callbackModal?: any
  setPagination?: any
  pagination?: any
  setReloadPagination?: any
  setSortOrder?: any
  sortOrder?: () => void
  scroll?: any
}

interface CallbackSortProps {
  column: {
    title: string
    dataIndex: string
    key: string | number
    width: number
    sorter: boolean
    sortOrder: string
    render: () => void
  }
  columnKey: string
  field: string
  order: 'descend' | 'ascend'
}

const MyTable: React.FC<Props> = ({
  columns,
  data,
  rowKey,
  loading,
  callbackModal,
  setPagination,
  pagination,
  setReloadPagination,
  setSortOrder,
  scroll,
}) => {
  const navigate = useNavigate()
  const location = useLocation()

  const callbackSort = (sort: CallbackSortProps) => {
    if (!sort || sort.order === undefined) return null

    if (sort.order === 'descend') return `-${sort.columnKey}`

    if (sort.order === 'ascend') return sort.columnKey
    return null
  }

  return (
    <Table
      className="my_table"
      columns={columns}
      dataSource={data}
      pagination={{ ...pagination, showSizeChanger: false }}
      rowKey={rowKey}
      loading={loading}
      scroll={scroll}
      onChange={(newPagination, filters, sorter: any, el: any) => {
        const urlSearchParams: any = new URLSearchParams(location.search)
        const currentParams: any = {}

        for (const [key, value] of urlSearchParams.entries()) {
          currentParams[key] = value
        }

        let newParams = {
          ...currentParams,
        }

        if (el.action === 'paginate') {
          newParams = { ...newParams, page: newPagination.current, page_size: newPagination.pageSize }

          setPagination(newPagination)
          setReloadPagination((prev: boolean) => !prev)
        }

        if (el.action === 'sort') {
          setSortOrder(sorter)
          const ordering = callbackSort(sorter)

          if (ordering) {
            newParams = { ...newParams, ordering, page: 1 }
            setPagination({ ...newPagination, current: 1 })
            setReloadPagination((prev: boolean) => !prev)
          } else {
            delete newParams.ordering
            setReloadPagination((prev: boolean) => !prev)
          }
        }

        const updatedUrl = `${location.pathname}?${new URLSearchParams(newParams).toString()}`

        navigate(updatedUrl)
      }}
      onRow={(record) => {
        return {
          onClick: (e: any) => {
            if (e.target.closest('.ant-image-mask') || e.target.closest('.ant-image-preview-img')) {
              e.preventDefault()
            } else {
              if (callbackModal) callbackModal(record)
            }
          },
        }
      }}
    />
  )
}

export default MyTable
